import { LOGOUT, SET_USER_INFO } from "./mutationsType";

const emptyUserInfo = () => ({
  memberId: "",
  account: "",
  memberType: "",
  name: "",
  companyId: 0,
  departmentID: 0,
  state: 0
});

export const state = {
  userInfo: emptyUserInfo()
};

export const mutations = {
  [SET_USER_INFO]: (state, userInfo) => {
    state.userInfo = {
      ...emptyUserInfo(),
      ...(userInfo || {})
    };
  },
  [LOGOUT]: (state) => {
    state.userInfo = emptyUserInfo();
  }
};
